import React from "react";
import { Box, Typography, Paper, Chip } from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const SALE_TYPES = [
    {
        id: 1,
        icon: <ReceiptIcon sx={{ fontSize: 56 }} />,
        titleAr: "إيصال مع ضريبة",
        titleEn: "Invoice with Tax",
        description: "Taxed invoice with exchange rate support",
        color: "#1976d2",
        allowedRoles: [1, 2, 3],
    },
    {
        id: 2,
        icon: <MoneyOffIcon sx={{ fontSize: 56 }} />,
        titleAr: "إيصال بدون ضريبة",
        titleEn: "Invoice without Tax",
        description: "Standard sale invoice, no tax applied",
        color: "#2e7d32",
        allowedRoles: [1, 2, 3],
    },
    {
        id: 3,
        icon: <PersonIcon sx={{ fontSize: 56 }} />,
        titleAr: "مبيع شخصي",
        titleEn: "Personal Sale",
        description: "Internal / off-the-record sale",
        color: "#7b1fa2",
        allowedRoles: [1, 2],
    },
];

const AddSalesPage = () => {
    const navigate = useNavigate();
    const user = useAuthUser();
    const userRoleId = user?.employeeType?.id;

    const visibleTypes = SALE_TYPES.filter((t) =>
        t.allowedRoles.includes(userRoleId)
    );

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "70vh",
                gap: 2,
                px: 3,
            }}
        >
            <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
                Create Sale
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Select the type of sale to continue
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 3,
                    flexWrap: "wrap",
                    justifyContent: "center",
                }}
            >
                {visibleTypes.map((type) => (
                    <Paper
                        key={type.id}
                        elevation={3}
                        onClick={() =>
                            navigate(`/SelectCustomer?invoiceType=${type.id}`)
                        }
                        sx={{
                            width: 220,
                            p: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 1.5,
                            cursor: "pointer",
                            borderTop: `4px solid ${type.color}`,
                            transition: "transform 0.15s, box-shadow 0.15s",
                            "&:hover": {
                                transform: "translateY(-4px)",
                                boxShadow: 6,
                            },
                        }}
                    >
                        <Box sx={{ color: type.color }}>{type.icon}</Box>
                        <Typography
                            variant="h6"
                            fontWeight={600}
                            textAlign="center"
                        >
                            {type.titleAr}
                        </Typography>
                        <Chip
                            label={type.titleEn}
                            size="small"
                            sx={{
                                backgroundColor: type.color + "22",
                                color: type.color,
                                fontWeight: 600,
                                fontSize: 11,
                            }}
                        />
                        <Typography
                            variant="caption"
                            color="text.secondary"
                            textAlign="center"
                        >
                            {type.description}
                        </Typography>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
};

export default AddSalesPage;
